import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import ComputerIcon from '@mui/icons-material/Computer'

import { useQuery } from '~/client/hooks/cqrpc'
import CommandForm from '~/client/components/CommandForm'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'


export default function MySessionsList(){
  const query = useQuery('sessions.getMine')
  const sessions = query.result || []
  return <LoadingList {...{
    loading: query.loading,
    members: sessions.map(session => ({
      key: session.id,
      // href: `/login-attempts/${n.loginAttemptId}`,
      icon: <ComputerIcon sx={{ml: 2}}/>,
      text: "Los Angeles 98.97.140.148",
      subtext: <>
        {`Last accessed on `}<Timestamp at={session.createdAt}/>
      </>,
      suffix: session.currentSession
        ? <Button disabled variant="outlined">Current</Button>
        : <RevokeButton {...{ session, reload: query.reload }}/>
    }))
  }}/>
}

function RevokeButton({ session, reload }){
  return <CommandForm {...{
    renderError: false,
    formButtons: false,
    command: 'appAccounts.revokeSession',
    onSubmit(value, command) {
      command.call({ sessionId: session.id })
    },
    onFailure(error){
      toast.error(`${error}`)
    },
    onSuccess(){
      reload()
      toast.success('Session revoked!')
    },
  }}>{({ submitting }) => (
    <Button
      type="submit"
      variant="outlined"
      color="error"
    >{submitting ? 'REVOKING…' : 'REVOKE'}</Button>
  )}</CommandForm>
}
